const UserRole = {
  SuperAdmin: 'SUPER_ADMIN',
  TechnicalSupport: 'TECHNICAL_SUPPORT',
  Forwarder: 'FORWARDER',
  Dispatcher: 'DISPATCHER',
  MobileUser: 'MOBILE_USER'
}

export default UserRole
